export default __webpack_public_path__ + "static/media/card-outline.8ada5726.svg";